import { PortfolioModule } from './Public/_Portfolio/_MODULES/PortfolioModule';
import { AuthModule } from './Public/_Auth/_MODULES/AuthModule';
import { DashboardModule } from './Private/_Dashboard/_MODULES/DashboardModule';
import { ProfileModule } from './Private/_Profile/_MODULES/ProfileModule';
import { ProjectsModule } from './Private/_Projects/_MODULES/ProjectsModule';
import { ExperienceModule } from './Private/_Experience/_MODULES/ExperienceModule';
import { BlogModule } from './Private/_Blog/_MODULES/BlogModule';
import { SocialsModule } from './Private/_Socials/_MODULES/SocialsModule';
import { EmailModule } from './Private/_Email/_MODULES/EmailModule';
import { SaleProjectsModule } from './Private/_SaleProjects/_MODULES/SaleProjectsModule';
import { QuotesModule } from './Private/_Quotes/_MODULES/QuotesModule';

export const APP_MODULES_GET_PUBLIC_ROUTES = (dataUser = null, lang = 'es') => [
    ...PortfolioModule(dataUser, lang),
    ...AuthModule(dataUser, lang),
];

export const APP_MODULES = [
    PortfolioModule,
    AuthModule,
    DashboardModule,
    ProfileModule,
    ProjectsModule,
    SaleProjectsModule,
    QuotesModule,
    ExperienceModule,
    BlogModule,
    SocialsModule,
    EmailModule,
];

export const APP_MODULES_GET_PRIVATE_ROUTES = (dataUser = null, lang = 'es') => [
    ...DashboardModule(dataUser, lang),
    ...ProfileModule(dataUser, lang),
    ...ProjectsModule(dataUser, lang),
    ...SaleProjectsModule(dataUser, lang),
    ...QuotesModule(dataUser, lang),
    ...ExperienceModule(dataUser, lang),
    ...BlogModule(dataUser, lang),
    ...SocialsModule(dataUser, lang),
    ...EmailModule(dataUser, lang),
];

export const APP_MODULES_GET_ALL_ROUTES = (dataUser = null, lang = 'es') => [
    ...APP_MODULES_GET_PUBLIC_ROUTES(dataUser, lang),
    ...APP_MODULES_GET_PRIVATE_ROUTES(dataUser, lang),
];
